import type { ZipCodeType } from '@widget/api/queries/zipcodes/types';

export const getCountryName = (market: string) => (market === 'at' ? 'Österreich' : 'Deutschland');
export const getZipCodeLabel = (market: string) => (option: ZipCodeType | string) => {
  if (typeof option === 'string') {
    return option;
  }
  return option.zipCode || option.city
    ? `${option.zipCode}, ${option.city || option.region}, ${getCountryName(market)}`
    : '';
};
